import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import SeoHead from "./SeoHead";
import {
  buildStaticJsonLd,
  DEFAULT_SEO_IMAGE,
  resolveStaticSeo,
  SEO_LANGUAGES,
} from "./seoConfig";

const SeoManager = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const language = SEO_LANGUAGES.includes(i18n.resolvedLanguage)
    ? i18n.resolvedLanguage
    : SEO_LANGUAGES.includes(i18n.language)
    ? i18n.language
    : "en";

  const seo = useMemo(
    () =>
      resolveStaticSeo({
        pathname: location.pathname,
        search: location.search,
        language,
        t,
      }),
    [language, location.pathname, location.search, t]
  );

  const jsonLd = useMemo(
    () => buildStaticJsonLd({ seo, language }),
    [language, seo]
  );

  return (
    <SeoHead
      title={seo.title}
      description={seo.description}
      language={language}
      canonicalPath={seo.canonicalPath}
      image={DEFAULT_SEO_IMAGE}
      type={seo.schemaType === "Article" ? "article" : "website"}
      robots={seo.robots}
      jsonLd={jsonLd}
    />
  );
};

export default SeoManager;
